<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="For">F<span class="small">OREWORD</span></p>
<p class="para1">The importance of the state prison system to Huntsville, Texas, cannot be overemphasized. It is hard to imagine what our town would be like without the prisons, the jobs they afford, and their assistance to our community and the overall welfare of our town. Having the headquarters for a state agency—the Department of Criminal Justice—located here in addition to the five prisons inside our city limits is a huge boost to our economy. The general public can learn a lot about their prison system by visiting the Texas Prison Museum, rightly located in Huntsville, Texas.</p>
<p class="right">—James Willett<br/>Director of the Texas Prison Museum</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?6d31f9dc